<script>
	import UserStore from './stores/user';
	import Router from 'svelte-spa-router'
	import { push } from 'svelte-spa-router'
	import mainRoutes from './routes.js'
	import { addMessages, init , locale } from "svelte-i18n";

	const activeLink = '';;

	let routes;

	import en from "./locales/en.json";
	import he from "./locales/he.json";
	
	addMessages("en", en);
	addMessages("he", he);


	if (localStorage.getItem('user')=='' || localStorage.getItem('user')=='{}') {
		localStorage.setItem('user', '{}');
		push('/login');
	} else {
		let user = JSON.parse(localStorage.getItem('user'));
		UserStore.set(user)
	}

	init({
		initialLocale: "he",
	});	

	routes = mainRoutes;


	
</script>

<main>
	<Router {routes}/>
</main>